export function initSliderInput(elem) {
    const slider = elem.querySelector('input[type=range]');
    const text = elem.querySelector('input[type=number], input[type=text]');
    const zero = text.dataset.zero;

    const updateDisplay = () => {
        const num = parseFloat(slider.value);
        if(num == 0 && zero !== undefined) {
            text.type = 'text';
            text.removeAttribute('min');
            text.removeAttribute('max');
            text.value = zero;
        } else {
            text.type = 'number';
            text.min = slider.min;
            text.max = slider.max;
            text.value = num;
        }
    };

    slider.oninput = () => {
        updateDisplay();
    };

    text.onblur = () => {
        updateDisplay();
    };
    text.onfocus = () => {
        text.type = 'number';
        text.min = slider.min;
        text.max = slider.max;
        text.value = slider.value;
    };

    text.oninput = () => {
        slider.value = text.value;
    };

    updateDisplay();
}

export function initSliderInputs() {
    const sliders = Array.from(document.querySelectorAll('.input__slider'));
    for(const slider of sliders)
        initSliderInput(slider);
}
